import { C3HardwareItemType } from "../enums/c3-hardware-item-type.enum";

export const C3HardwareItemTypePrefix: Record<C3HardwareItemType, string> = {
    [C3HardwareItemType.Electronics]: 'E',
    [C3HardwareItemType.Motors]: 'MO',
    [C3HardwareItemType.SeljanSupplied]: 'SS',
    [C3HardwareItemType.Fastener]: 'F',
    [C3HardwareItemType.Miscellaneous]: 'M'
}